import Worker from "./md5_worker?worker";

const validatePhoneNumber = (phoneNumber: string): boolean => {
  const regex = /^1[3456789]\d{9}$/; // 正则表达式，匹配11位数字，第一位不能为0
  return regex.test(phoneNumber);
};

const formatTime = (totalSeconds: number): string => {
  const hours: number = Rounding(totalSeconds / 3600);
  const hh: string = (hours < 10 ? "0" + hours : hours).toString();
  const minutes: number = Rounding((totalSeconds - hours * 3600) / 60);
  const mm: string = minutes < 10 ? "0" + minutes : minutes.toString();
  const seconds: number = Rounding(totalSeconds - hours * 3600 - minutes * 60);
  const ss: string = seconds < 10 ? "0" + seconds : seconds.toString();
  const str: string = hh + ":" + mm + ":" + ss;
  return str;
};
// 取整数
const Rounding = (num: number): number => {
  return Number(num.toFixed(0));
};

// 防抖
const debounce = (fn: (...args: unknown[]) => void, delay: number = 500) => {
  let timer: NodeJS.Timeout | null;
  // 闭包
  return (...args: unknown[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      return fn(...args);
    }, delay);
  };
};

const getFileMD5 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target && event.target.result instanceof ArrayBuffer) {
        try {
          const worker: Worker = new Worker(); // 生成md5是耗时操作，需要使用worker

          // 处理 Worker 成功返回
          worker.onmessage = (e) => {
            resolve(e.data);
            worker.terminate(); // 释放worker
          };

          // 处理 Worker 错误（资源加载失败、执行错误等）
          worker.onerror = (error) => {
            console.error('Worker 执行错误:', error);
            reject(new Error('文件MD5计算失败，请检查网络连接'));
            worker.terminate();
          };

          worker.postMessage(event.target.result);
        } catch (error) {
          // 捕获 Worker 创建失败（如资源加载失败）
          console.error('Worker 创建失败:', error);
          reject(new Error('文件处理失败，请检查网络连接'));
        }
      } else {
        reject(new Error('无法读取文件内容'));
      }
    };
    reader.onerror = (error) => {
      console.error('文件读取失败:', error);
      reject(new Error('文件读取失败'));
    };
    reader.readAsArrayBuffer(file);
  });
}

const calculateBlobMD5 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event.target?.result instanceof ArrayBuffer) {
          // 创建Web Worker
          const worker: Worker = new Worker(); // 生成md5是耗时操作，需要使用worker

          // 处理Worker返回的结果
          worker.onmessage = (e) => {
            resolve(e.data);
            worker.terminate(); // 释放Worker
          };

          // 处理Worker错误
          worker.onerror = (error) => {
            reject(error);
            worker.terminate();
          };

          // 发送数据到Worker进行处理
          worker.postMessage(event.target.result);
        } else {
          reject(new Error('Failed to read file as ArrayBuffer'));
        }
      };

      reader.onerror = (error) => {
        reject(error);
      };

      // 开始读取文件
      reader.readAsArrayBuffer(blob);
    } catch (error) {
      reject(error);
    }
  });
};

const copyText = async (text: string): Promise<boolean> => {
  // 优先使用 Clipboard API
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Clipboard API 失败时降级
      return _onExecCommand(text);
    }
  }
  // 不支持 Clipboard API 时降级
  return _onExecCommand(text);
};

const _onExecCommand = (text: string): boolean => {
  try {
    const input = document.createElement('input');
    input.readOnly = true;
    input.value = text;
    input.style.position = 'fixed'; // fixed 更安全
    input.style.opacity = '0';
    input.style.left = '-9999px';
    input.style.top = '-9999px';
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    const result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
  } catch {
    return false;
  }
};

export { calculateBlobMD5, validatePhoneNumber, formatTime, debounce, getFileMD5, copyText };
